export const testimonials = {
  testimonialsPageTitle: "Testimonios Ganadores — Aprieta y Gana",
  testimonialsPageDescription:
    "Conoce las historias de nuestros ganadores reales. Videos de testimonios de jugadores que ganaron en Aprieta y Gana.",
  testimonialsTitle: "Testimonios Ganadores",
  testimonialsSubtitle: "Historias reales de nuestros ganadores",
  testimonialsFilterLabel: "Filtrar testimonios",
  testimonialsFilter_all: "Todos",
  testimonialsFilter_horizontal: "Horizontal",
  testimonialsFilter_vertical: "Vertical",
  testimonialsEmpty: "Aún no hay testimonios disponibles",
  testimonialsPaginationLabel: "Paginación de testimonios",
  testimonialsPrevPage: "Página anterior",
  testimonialsNextPage: "Página siguiente",
  testimonialsPage: "Página",

  stickyRegisterTitle: "¡Regístrate y Gana!",
  stickyRegisterSubtitle: "Crea tu cuenta gratis y empieza a jugar ahora",
  stickyRegisterAlreadyHaveAccount: "¿Ya tienes cuenta?",
  stickyRegisterLogin: "Inicia sesión",
};
